import { apiFetch } from './client';
import type { Activity, Person, Deal, Issue, Paginated, ContactCompany } from '$lib/types';
import type { ListParams, OwnershipHistory } from './crm';
export function query(params: ListParams): string {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) if (value !== undefined && value !== '') search.set(key, String(value));
  return `?${search}`;
}
export interface ContactSummary {
  company?: ContactCompany | null;
  person: Person; first_contact_at: string | null; last_contact_at: string | null;
  conversation_count: number; open_deals: number; open_cases: number;
  deals: Deal[]; cases: Issue[]; company_people: Person[]; lead_source: string;
  latest_feedback: Record<string, unknown> | null; upcoming: Activity[]; ownership_history: OwnershipHistory[];
}
export interface TimelineEvent {
  id: string; kind: string; at: string; summary: string; actor_name?: string;
  activity?: Activity; deal_id?: number; issue_id?: number;
}
export const touchpointsApi = {
  summary: (id: number) => apiFetch<ContactSummary>(`/people/${id}/summary`),
  timeline: (id: number, kind: string, cursor = '') => apiFetch<{ results: TimelineEvent[]; next_cursor: string | null; count: number }>(`/people/${id}/timeline${query({ kind, cursor, per_page: 25 })}`),
  viewCounts: (params: ListParams) => apiFetch<Record<string, number>>(`/people/view-counts${query(params)}`),
  buckets: (params: ListParams) => apiFetch<Record<string, number>>(`/activities/bucket-counts${query(params)}`),
  list: (params: ListParams) => apiFetch<Paginated<Activity>>(`/activities${query(params)}`),
  // No transparent retries of writes after ambiguous failures.
  write: (path: string, body: Record<string, unknown>, method = 'POST') => apiFetch<Activity>(path, { method, body: JSON.stringify(body) }, true),
  complete: (id: number, body: Record<string, unknown>) => touchpointsApi.write(`/activities/${id}/complete`, body),
  reschedule: (id: number, body: Record<string, unknown>) => touchpointsApi.write(`/activities/${id}/reschedule`, body)
};
